import { useFetchInvoicesSummary } from '../../../../../../../hooks/useFetchInvoicesSummary'
import { useInvoicesListFilters } from '../../../../../context/invoicesListFilters'

export const useInvoicesSummaryFiltered = () => {
  const [{ customerId, period, searchQuery }] = useInvoicesListFilters()

  return useFetchInvoicesSummary({ customerId, period, searchQuery })
}
